var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{directives:[{name:"show",rawName:"v-show",value:(_vm.sex != null),expression:"sex != null"}],attrs:{"color":_vm.colorSex(_vm.sex),"dark":"","label":"","x-small":""}},[_vm._v(" "+_vm._s(_vm.sex)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }